enum RequestEnterprise {
  MT = 'METROPOLIS',
  XM = 'XMOVA',
  CD = 'CODE'
}

export default RequestEnterprise;
